import React from 'react';
import { Link } from 'react-router-dom';
import { abbreviateNumber } from 'js-abbreviation-number';

const SearchVideoCard = ({item}) => {
  return (
    <Link to={`/video/${item?.video?.videoId}`}>
      <div className='flex md:flex-row flex-col mt-10'>
        <div className='md:w-[30%]'>
          <img src={item?.video?.thumbnails?.[0]?.url} className='w-[100%] md:rounded-xl' alt="Suggestion_video" />
        </div>
        <div className='md:w-[65%] ml-3'>
          <h1 className='text-[18px] font-bold text-white line-clamp-2'>{item?.video?.title}</h1>
          <div className='flex mt-3'>
            <div className='mt-2'>
              <img src={item?.video?.author?.avatar[0]?.url} className='w-9 h-9 object-cover mr-2 rounded-full' alt="Channel_Img" />
            </div>
            <div>
              <p className='text-white/[0.6] text-sm'>{item?.video?.author?.title}</p>
              <span className='text-white/[0.6] text-sm'>{`${abbreviateNumber(item?.video?.stats?.views, 2)} Views • ${item?.video?.publishedTimeText}`}</span>
            </div>
          </div>
          <div className='text-white mt-4 text-sm'>
            {item?.video?.descriptionSnippet}
          </div>
        </div>
      </div>
    </Link>
  )
}

export default SearchVideoCard
